import React, { useContext } from 'react';
import ReactSVG from 'react-svg';
import { ThemeContext } from '../../store/ThemeProvider';
// 请在外层直接引用gallery-list样式
interface ITimeline {
  time: string;
}
const Timeline = function(props: ITimeline) {
  const { mainColor } = useContext(ThemeContext);
  return (
    <div className="time-line">
      <ReactSVG
        src={require('../../svg/clock.svg')}
        className={'clock'}
        style={{ color: mainColor }}
      />
      {props.time}
    </div>
  );
};

export default Timeline;
